/* version 1.1.4 */
// Import this Class, and call 'initialize' when dom is loaded
// Note: 'navigation' const is used on DesktopMetal.com for the sticky nav open/close - you may need to adjust this functionality per your site
class TeamDMDropdownController {

	initialize() {
		this.teamDMDropdown();
	}

	teamDMDropdown() {
		const teamDMDropdown = document.getElementById('js-team-dm-dropdown');
		const toggleLabel = document.querySelector('.js-team-dm-dropdown-bar-toggle-label');
		const toggleCheckbox = document.getElementById('team-dm-dropdown-toggle');
		const navigation = document.querySelector('.navigation');
		const mobileHamburgerButton = document.getElementById('js-mobile-hamburger-button');

		if (teamDMDropdown) {
			// Team DM Drop Down -> Make enter key press on label trigger dropdown
			toggleLabel.addEventListener('keypress', (e) => {
				if (e.keyCode === 13) { // If the the enter key was pressed.
					toggleCheckbox.click();
				}
			});

			// Close the Team DM Drop down if clicking outside
			window.addEventListener('click', (e) => {
				if (!teamDMDropdown.contains(e.target)) {
					if (toggleCheckbox.checked) {
						toggleCheckbox.click();
					}
				}
			});

			// @DEV Added 'close' and 'sticky' settings to the header.js and header.scss
		}
	}

}

export default new TeamDMDropdownController();
